import { KeyValuePair } from "../commonInterfaces.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService } from "../core/util/httpManager.js";
import { IncomingGoodsEntity } from "./incomingGoods.js";
export class StocksService {
    public static book = async (entity: IncomingGoodsEntity) => {
        const goods: IncomigGood[] = entity.Goods.map((good) => {
            return {
                AdrNr: entity.AdrNr,
                Anzahl: good.Anzahl,
                ArtikelNr: good.ArtikelNr,
                ChargenNr: good.ChargenNr,
                Comment: good.Comment,
                DeliveryBillId: entity.DeliveryBillId,
                Pos: good.Pos,
                ProjNr: good.ProjNr,
                SerienNr: good.SerienNr,
                Source: good.Source,
                State: good.State,
                Lagerplatzid: good.Lagerplatzid,
                TargetAdrNr: good.TargetAdrNr,
                Lagerid: good.Lagerid
            }
        })
        const result = await HTTPService.post("Stock/BookIncomingGoods", {
            incomigGoods: goods
        });

        return result;
    }

    public static getTypes = async (subId: number) => {
        const key = `STOCKS_SUB_ID_${subId}`;
        let data: KeyValuePair<number, string>[] = Helper.loadDataFromStorage(key);
        if (!Helper.hasValue(data)) {
            data = await HTTPService.get<KeyValuePair<number, string>[]>("Warehouse/GetVtyps?subId=" + subId)
            Helper.saveDataToStorage(key, data, false)
        }
        return data;
    }
    
} 
interface IncomigGood {
    Lagerid: number;
    Lagerplatzid: number;
    Source: number;
    State: number;
    TargetAdrNr: string;
    ProjNr: string;
    AdrNr: number;
    DeliveryBillId: string;
    Pos: number;
    ArtikelNr: number;
    ChargenNr: string;
    SerienNr: string;
    Anzahl: number;
    Comment: string;
}